import Button from "../../../componentsNew/Button";
import { CampoInputBase } from "../../../componentsNew/Input/CampoInput/CampoInputBase";
import Typography from "../../../componentsNew/Typography";
import star from "../../../assets/img/stars-02.svg"
import Card from "../../../componentsNew/Card";
import Select from "../../../componentsNew/Select";
import { IoIosArrowDown } from "react-icons/io";
import { ObterSugestoesTema, useSugestoesTema } from "../../../api/controllers/optiGenerator";
import { useSelect } from "@wordpress/data"
import { useEffect, useState } from "@wordpress/element";
import { store } from "../../../redux/store";
import CircularProgress from "../../../componentsNew/CircularProgress";
import { CustomWarning } from "@componentsNew/CustomWarning";
import { alert } from "@componentsNew/CustomWarning/types";

export function StepContexto({ form, mudarValor }) {

    const idUsuario = useSelect(select => select(store).getUsuarioIdOpti())

    const [sugestoes, setSugestoes] = useState([]);

    const [loadingIa, setLoadingIa] = useState(false)
    const [errorIa, setErrorIA] = useState(false)

    function obterSugestoesAction() {
        if (sugestoes[0] > 0 || sugestoes.length > 0) {
            mudarValor("tema", sugestoes[0])
            sugestoes.shift()
        } else {
            setLoadingIa(true)
            ObterSugestoesTema(idUsuario).then(({ data }) => {
                setSugestoes(data.sugestoes)

            }).catch(() => {
                console.log("erro")
                setErrorIA(true)
            })
        }
    }

    useEffect(() => {
        mudarValor("tema", sugestoes[0])
        sugestoes.shift()
        setLoadingIa(false)
    }, [sugestoes.length > 0])

    return (
        <>
            <Card className="px-4 py-3 text-center !shadow-[0px_5px_4px_0px_rgba(0,0,0,0.20)]">
                <Typography component="body-secundary-bold">Descreva um tema e um contexto ou deixe que nossa IA crie para você!</Typography>
            </Card>

            {loadingIa && !errorIa && <>
                <div className="flex flex-col items-center">
                    <CircularProgress className="mt-8" />
                    <p className="text-center mt-4">Estamos gerando o seu tema...</p>
                </div>
            </>}
            {errorIa && <CustomWarning
                alertType={alert.error}
                content={
                    <Typography className="font-[0.75rem] mt-4">
                        Houve um erro inesperado ao tentar gerar o artigo, tente novamente mais tarde.
                    </Typography>
                } />}

            {!loadingIa && <>
                <CampoInputBase
                    label="Tema"
                    className="mt-8"
                    textarea
                    rows="3"
                    valor={form.tema}
                    placeholder="Digite o tema do texto"
                    setValor={e => mudarValor("tema", e)}
                />
                <CampoInputBase
                    textarea
                    rows="3"
                    className="mt-8"
                    placeholder="Forneça uma breve descrição sobre o conteúdo do artigo (Ex: Dicas para melhorar a produtividade no trabalho remoto)"
                    label="Descreva o texto do artigo"
                    valor={form.descricao}
                    setValor={e => mudarValor("descricao", e)}
                />
                <Select
                    className="mt-8"
                    component="active"
                    valorInput={form.objetivo}
                    setValorInput={e => mudarValor("objetivo", e)}
                    label="Objetivo"
                    icon={<IoIosArrowDown className="w-4 text-text-secundary" />}
                    opcoes={[
                        { valor: 'Tempo de Engajamento', titulo: 'Tempo de Engajamento' },
                        { valor: 'Vendas', titulo: 'Vendas' },
                        { valor: 'Anúncio', titulo: 'Anúncio' },
                        { valor: 'Redirecionar a um link', titulo: 'Redirecionar a um link' }
                    ]}
                //carregando={carregando}
                //desabilidato={desabilidato}
                //renderValue={renderValue}
                //checkbox={checkbox} 
                />
                <div className="flex justify-end w-full">
                    <Button onClick={() => obterSugestoesAction()} component="outlined" className="w-3/5 mt-8">
                        <Typography component="button"><img src={star} className="mr-2" /> Gerar novas sugestões</Typography>
                    </Button>
                </div>
            </>}

        </>
    )
}